import { render, staticRenderFns } from "./About.vue?vue&type=template&id=159ac110&scoped=true&lang=pug"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
import style0 from "./About.vue?vue&type=style&index=0&id=159ac110&prod&lang=stylus&scoped=true"
import style1 from "./About.vue?vue&type=style&index=1&id=159ac110&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159ac110",
  null
  
)

export default component.exports